/**
 * PR-AdminUsers-9 — Card de área asignada al usuario.
 * Muestra nombre, rol, segmento padre y accesos rápidos al área.
 */
import { Link } from "react-router-dom";
import { Settings2, ExternalLink } from "lucide-react";
import { cn } from "@/lib/utils";

interface AreaCardProps {
  areaCode: string;
  areaName: string;
  role: "operator" | "manager";
  segmentCode?: string;
  segmentRoute?: string;
}

const ROLE_LABELS: Record<string, string> = {
  manager: "Manager",
  operator: "Operador",
};

export function AreaCard({ areaCode, areaName, role, segmentRoute }: AreaCardProps) {
  return (
    <div className={cn(
      "rounded-lg border bg-card p-4 space-y-3 flex flex-col",
      role === "manager" && "border-primary/30",
    )}>
      <div className="flex items-start justify-between gap-2">
        <div>
          <p className="font-medium text-sm">{areaName}</p>
          <p className="text-xs text-muted-foreground font-mono mt-0.5">{areaCode}</p>
        </div>
        <span className={cn(
          "shrink-0 rounded-full px-2 py-0.5 text-[10px] font-semibold",
          role === "manager"
            ? "bg-amber-500/15 text-amber-700 dark:text-amber-400"
            : "bg-muted text-muted-foreground",
        )}>
          {ROLE_LABELS[role] ?? role}
        </span>
      </div>

      <div className="flex items-center gap-2 mt-auto pt-1">
        {segmentRoute && (
          <Link
            to={segmentRoute}
            className="flex items-center gap-1.5 text-xs text-primary hover:underline"
          >
            <ExternalLink className="size-3" /> Ver módulo
          </Link>
        )}
        {role === "manager" && (
          <Link
            to={`/settings/area/${areaCode}`}
            className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground ml-auto"
          >
            <Settings2 className="size-3" /> Configurar
          </Link>
        )}
      </div>
    </div>
  );
}
